module.exports = __webpack_public_path__ + "static/img/AMac.f8d905b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/AMac.png
// module id = EaA6
// module chunks = 1